var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamptonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 25",
    enableBackground: "new 0 0 42 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M0 0h9v5H0zM11 0h9v5h-9zM22 0h9v5h-9zM33 0h9v5h-9zM0 10h9v5H0zM11 10h9v5h-9zM22 10h9v5h-9zM33 10h9v5h-9zM0 20h9v5H0zM11 20h9v5h-9zM22 20h9v5h-9zM33 20h9v5h-9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamptonIcon);
export default __webpack_public_path__ + "static/media/hampton_icon.72273ec6a3ab74af439a342e812f10df.svg";
export { ForwardRef as ReactComponent };